import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { connectRouter, routerMiddleware } from "connected-react-router";
import webSocketMiddleware from "../_middlewares/webSocketMiddleware";
import createUrlSyncMiddleware from "../_middlewares/urlSyncMiddleware";

import * as appSettings from "./appSettings";
import * as errors from "./errors";
import * as mainMenu from "./mainMenu";
import * as mainTabs from "./mainTabs";
import * as feederLists from "./feederLists";
import * as adr from "./adr";
import * as projects from "./projects";
import * as projComponents from "./projComponents";
import * as bidItems from "./bidItems";
import * as ccos from "./ccos";
import * as pendingIssues from "./pendingIssues";
import * as locations from "./locations";
import * as keywords from "./keywords";
import * as contractors from "./contractors";
import * as labors from "./labors";
import * as laborCrews from "./laborCrews";
import * as equipment from "./equipment";
import * as dash from "./dash";
import * as reports from "./reports";
import * as users from "./users";
import * as authentication from "./authentication";
import * as fieldOffices from "./fieldOffices";
import * as issues from "./issues";
import * as tests from "./tests";
import * as overtimes from "./overtimes";
import * as updateNotes from "./updateNotes";
import * as qms from "./qms";
import * as payEstimate from "./payEstimate";
// import verifyTokenMiddleware from "../_middlewares/verifyTokenMiddleware";

export default function configureStore(history, initialState) {
  const reducers = {
    appSettings: appSettings.reducer,
    errors: errors.reducer,
    mainMenu: mainMenu.reducer,
    mainTabs: mainTabs.reducer,
    feederLists: feederLists.reducer,
    adr: adr.reducer,
    projects: projects.reducer,
    projComponents: projComponents.reducer,
    bidItems: bidItems.reducer,
    ccos: ccos.reducer,
    pendingIssues: pendingIssues.reducer,
    locations: locations.reducer,
    keywords: keywords.reducer,
    contractors: contractors.reducer,
    equipment: equipment.reducer,
    labors: labors.reducer,
    laborCrews: laborCrews.reducer,
    dash: dash.reducer,
    reports: reports.reducer,
    users: users.reducer,
    authentication: authentication.reducer,
    fieldOffices: fieldOffices.reducer,
    issues: issues.reducer,
    tests: tests.reducer,
    overtimes: overtimes.reducer,
    updateNotes: updateNotes.reducer,
    qms: qms.reducer,
    payEstimate: payEstimate.reducer,
  };

  const middleware = [thunk, routerMiddleware(history), webSocketMiddleware, createUrlSyncMiddleware(history)];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === "development";
  if (
    isDevelopment &&
    typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION__
  ) {
    // enhancers.push(window.devToolsExtension());
    enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
  }

  const rootReducer = () =>
    combineReducers({
      ...reducers,
      router: connectRouter(history),
    });

  return createStore(
    // connectRouter(history)(rootReducer),
    rootReducer(),
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}
